import { Modal } from "../Modal";
import { Row } from "../Modal/Row";

import { useSettings } from "../../contexts/Settings";
import { ModalLocation } from "../../types/modalLocation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDisplay, faGauge } from "@fortawesome/free-solid-svg-icons";
import { usePlaybackRate } from "../../contexts/PlaybackRate";
import { useVideoSource } from "../../contexts/VideoSource";

export const SettingsModal = () => {
  const {
    showBaseModal,
    setShowBaseModal,
    setShowPlaybackRateModal,
    setShowResolutionsModal,
  } = useSettings();
  const { playbackRate, isEnabled: playbackRateEnabled } = usePlaybackRate();
  const { currentQualityLevel, qualityLevels } = useVideoSource();

  const currentLevel = qualityLevels?.find(
    (level) => currentQualityLevel?.id === level.id
  );

  const closeSelf = () => {
    setShowBaseModal(false);
  };

  const openPlaybackRate = () => {
    closeSelf();
    setShowPlaybackRateModal(true);
  };

  const openResolutions = () => {
    closeSelf();
    setShowResolutionsModal(true);
  };

  return (
    <Modal
      modalLocation={ModalLocation.bottomRight}
      show={showBaseModal}
      closeSelf={closeSelf}
      width={130}
    >
      {qualityLevels !== undefined && qualityLevels.length > 1 && (
        <Row
          onClick={openResolutions}
          hasArrow
          icon={<FontAwesomeIcon icon={faDisplay} />}
          label={`${currentLevel?.label}`}
        />
      )}

      {playbackRateEnabled && (
        <Row
          hasArrow
          label={`${playbackRate}x`}
          onClick={openPlaybackRate}
          icon={<FontAwesomeIcon icon={faGauge} />}
        />
      )}
    </Modal>
  );
};
